import React from 'react'
import { Box, Card, IconButton, CardContent, Typography, Grid, Divider, TextField } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import OverflowTooltip from '../../helpers/OverflowTooltip';
import { formatDate } from '../../helpers/handleDate';

function Personal({ employeeData }) {
    return (
        <Grid container
            sx={{
                display: 'flex',
                // justifyContent: 'space-between',
                alignItems: 'center',
                // gap: 2,
                padding: { xs: 0, sm: 3 },
                borderRadius: '10px',
            }}
        >
            {/* Left Section: Details */}
            <Grid item sm={12} md={8} /* sx={{ flex: 1 }} */>
                <Grid container spacing={2} >
                    {/* Row 1 */}
                    <Grid item xs={12} sm={6}>
                        <Typography variant="body1" sx={{ color: '#9E9E9E', fontSize: '14px' }}>
                            DOB
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#000001DE', fontSize: { md: "17px", lg: "20px" } }}>
                            {employeeData?.personal?.dob_in_cert ? formatDate(employeeData.personal.dob_in_cert) : 'N/A'}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="body1" sx={{ color: '#9E9E9E', fontSize: '14px' }}>
                            Alternate Contact No
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#5ECF4D', fontSize: { md: "17px", lg: "20px" } }}>{employeeData?.personal?.alt_phone || 'N/A'}</Typography>
                    </Grid>

                    {/* Row 2 */}
                    <Grid item xs={12} sm={6} sx={{ marginTop: { xs: '0', sm: '35px' } }}>
                        <Typography variant="body1" sx={{ color: '#9E9E9E', fontSize: '14px' }}>
                            Marital Status
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#000001DE', fontSize: { md: "17px", lg: "20px" } }}>{employeeData?.personal?.marital_status || 'N/A'}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} sx={{ marginTop: { xs: '0', sm: '35px' } }}>
                        <Typography variant="body1" sx={{ color: '#9E9E9E', fontSize: '14px' }}>
                            Personal Email ID
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#1976D2', fontSize: { md: "17px", lg: "20px" } }}>{employeeData?.personal?.personal_email || 'N/A'}</Typography>
                    </Grid>


                    {/* Row 3 */}
                    <Grid item xs={12} sm={6} sx={{ marginTop: { xs: '0', sm: '35px' } }}>
                        <Typography variant="body1" sx={{ color: '#9E9E9E', fontSize: '14px' }}>
                            Father’s / Spouse name
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#000001DE', fontSize: { md: "17px", lg: "20px" } }}>{employeeData?.personal?.father_spouse_name || 'N/A'}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} sx={{ marginTop: { xs: '0', sm: '35px' } }}>
                        <Typography variant="body1" sx={{ color: '#9E9E9E', fontSize: '14px' }}>
                            Nationality
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#000001DE', fontSize: { md: "17px", lg: "20px" } }}>{employeeData?.personal?.nationality || 'N/A'}</Typography>
                    </Grid>

                    {/* Row 4 */}
                    <Grid item xs={12} sm={6} sx={{ marginTop: { xs: '0', sm: '35px' } }}>
                        <Typography variant="body1" sx={{ color: '#9E9E9E', fontSize: '14px' }}>
                            Official Email ID
                        </Typography>
                        <OverflowTooltip><Typography variant="body2" sx={{ color: '#1976D2', fontSize: { md: "17px", lg: "20px" } }}>{employeeData?.personal?.official_email_id || 'N/A'}</Typography>
                        </OverflowTooltip>
                        </Grid>
                    <Grid item xs={12} sm={6} sx={{ marginTop: { xs: '0', sm: '35px' } }}>
                        <Typography variant="body1" sx={{ color: '#9E9E9E', fontSize: '14px' }}>
                            Blood Group
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#000001DE', fontSize: { md: "17px", lg: "20px" } }}>{employeeData?.personal?.bg || 'N/A'}</Typography>
                    </Grid>
                </Grid>
            </Grid>

            {/* Right Section: Emergency Contact Card */}
            <Grid item xs={12} md={4} sx={{ marginTop: { xs: "25px", md: '0' } }}>
                <Card
                    sx={{
                        // width: '35%',
                        height: '100%',
                        padding: 2,
                        borderRadius: '10px',
                        backgroundColor: '#f1f4f9',
                    }}
                >
                    <CardContent >
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography variant="h6" /* gutterBottom */ sx={{ color: '#481E82', fontSize: { xs: "15px", md: "20px", lg: '34px' } }}>
                                Emergency Contact
                            </Typography>
                            {/* <IconButton>
                                <EditIcon />
                            </IconButton> */}
                        </Box>
                        <Grid item xs={12} sx={{ marginTop: '25px', backgroundColor: 'white', padding: '5px' }}>
                            <Typography variant="body1" sx={{ color: '#9E9E9E', fontSize: '14px' }}>Name</Typography>
                            <Typography variant="body2" sx={{ color: 'black', fontSize: '18px' }}>{employeeData?.emergency_contact?.name || 'N/A'}</Typography>
                        </Grid>
                        <Grid item xs={12} sx={{ marginTop: '25px', backgroundColor: 'white', padding: '5px' }}>
                            <Typography variant="body1" sx={{ color: '#9E9E9E', fontSize: '14px' }}>Relation</Typography>
                            <Typography variant="body2" sx={{ color: 'black', fontSize: '18px' }}>{employeeData?.emergency_contact?.relation || 'N/A'}</Typography>
                        </Grid>
                        <Grid item xs={12} sx={{ marginTop: '25px', backgroundColor: 'white', padding: '5px' }}>
                            <Typography variant="body1" sx={{ color: '#9E9E9E', fontSize: '14px' }}>Contact No</Typography>
                            <Typography variant="body2" sx={{ color: 'black', fontSize: '18px' }}>{employeeData?.emergency_contact?.mobile_num || 'N/A'}</Typography>
                        </Grid>

                    </CardContent>
                </Card>
            </Grid>

        </Grid>
    );
}


export default Personal